//File imports
import HttpService from '../../../services/Http/HttpService';
import Logger from '../../../services/Logger/Logger';
import Validator from '../../../services/Validator/Validator';
import {
    API_CREATE_DOCUMENT_TEMPLATE,
    API_DELETE_DOCUMENT_TEMPLATE,
    API_GET_ALL_DOCUMENT_TEMPLATES,
    API_UPDATE_DOCUMENT_TEMPLATE,
} from './DocumentTemplateConstants';
import DocumentTemplatesResultsPojo from './DocumentTemplateResultPojo';

export class DocumentTemplateService {
    private httpService = new HttpService();
    private logger = new Logger();
    private validator = new Validator();

    async getAll(): Promise<DocumentTemplatesResultsPojo> {
        try {
            const httpResult = await this.httpService.get(
                API_GET_ALL_DOCUMENT_TEMPLATES,
                {},
            );
            return {
                isSuccess: httpResult.data.isSuccess,
                documentTemplates: httpResult.data.response,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async delete(documentTemplateId: number, status: number): Promise<Boolean> {
        try {
            this.validator.validatePositiveInteger(documentTemplateId);
            this.validator.validateIntegerIncludingZero(status);

            const httpResult = await this.httpService.delete(
                API_DELETE_DOCUMENT_TEMPLATE,
                { documentTemplateId, status },
            );
            return httpResult.data.isSuccess;
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async create(
        name: string,
        price: number,
        outsidePrice: number,
        preparationTimeInMinutes: number,
        isInstructionsOnlyDocument: boolean,
    ): Promise<{ success: boolean; message: string }> {
        try {
            this.validator.isValidString('Name', name);
            this.validator.isNumberGreaterThan('Price', price, 0);
            this.validator.isNumberGreaterThan(
                'Outside Price',
                outsidePrice,
                0,
            );
            this.validator.isNumberGreaterThan(
                'Preparation Time',
                preparationTimeInMinutes,
                0,
            );
            this.validator.validateBoolean(
                'Is Instructions Only Document',
                isInstructionsOnlyDocument,
            );

            const payload = {
                name,
                price,
                outsidePrice,
                preparationTimeInMinutes,
                isInstructionsOnlyDocument,
            };

            const httpResult = await this.httpService.post(
                API_CREATE_DOCUMENT_TEMPLATE,
                payload,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async update(
        documentTemplateId: number,
        name: string,
        price: number,
        outsidePrice: number,
        preparationTimeInMinutes: number,
        isInstructionsOnlyDocument: boolean,
    ): Promise<{ success: boolean; message: string }> {
        try {
            this.validator.validatePositiveInteger(documentTemplateId);
            this.validator.isValidString('Name', name);
            this.validator.isNumberGreaterThan('Price', price, 0);
            this.validator.isNumberGreaterThan(
                'Outside Price',
                outsidePrice,
                0,
            );
            this.validator.isNumberGreaterThan(
                'Preparation Time',
                preparationTimeInMinutes,
                0,
            );
            this.validator.validateBoolean(
                'Is Instructions Only Document',
                isInstructionsOnlyDocument,
            );

            const payload = {
                documentTemplateId,
                name,
                price,
                outsidePrice,
                preparationTimeInMinutes,
                isInstructionsOnlyDocument,
            };
            const httpResult = await this.httpService.put(
                API_UPDATE_DOCUMENT_TEMPLATE,
                payload,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }
}
